module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "chap-002"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_tit"
  }, [_c('span', [_vm._v("9:1-5 PAUL ANGUISHES OVER HIS OWN PEOPLE")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('i', [_vm._v("I am speaking the truth in Christ—I am not lying; my conscience bears me witness in the Holy Spirit—"), _c('sup', [_vm._v("2")]), _vm._v("that I have great sorrow and unceasing anguish in my heart. "), _c('sup', [_vm._v("3")]), _vm._v("For I could wish that I myself were accursed and cut off from Christ for the sake of my brothers,")])]), _c('i', [_c('a', {
    staticClass: "apnb",
    attrs: {
      "href": "#/p1chap2#NTB1",
      "id": "ap_NTB1-1"
    }
  }, [_vm._v("*1")]), _vm._v(" my kinsmen according to the flesh. "), _c('sup', [_vm._v("4")]), _vm._v("They are Israelites, and to them belong the adoption, the glory, the covenants, the giving of the law, the worship, and the promises. "), _c('sup', [_vm._v("5")]), _vm._v("To them belong the patriarchs, and from their race, according to the flesh, is the Christ, who is God over all, blessed forever. Amen.")])]), _c('hr', {
    staticClass: "sep_hr"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERVIEW")]), _vm._v(":")]), _vm._v(" How Paul begins the difficult and painful discussion of the rejection of his people shows the reformers his rhetorical dexterity. As if he were smearing honey on the brim of a cup of bitter medicine, Paul speaks to his readers with kindness and gentleness in anticipation of the looming condemnation."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN113",
      "id": "ap_NFIN113-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" Through this strategy—which he often wields—he disarms a potentially hostile audience, so that they might receive his message more readily. He is no enemy of the Jewish nation, no despiser of Mosaic law. On the contrary, he loves the law, and he longs for his Jewish brothers and sisters to understand it fully, that all the advantages and benefits of Israel point to Christ. To prove how serious he is, he even wishes that he would be damned that they might live ("), _c('i', [_vm._v("resignatio ad infernum")]), _vm._v(").")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Paul’s praise for the Jewish people reaches its pinnacle in the confession that Jesus of Nazareth, who is God and man, is their brother. These commentators cannot help but see the careful theological grammar Paul uses in Romans 9:5—later affirmed and canonized by the Council of Chalcedon (451). According to his human nature, Christ belongs to the fleshly heritage of the patriarchs; according to his divine nature, he is eternally blessed. The apostle skillfully holds together Christ’s natures—distinguishable but inseparable—in the unity of his person. Israel’s greatest blessing is that the eternal God chose to condescend into human flesh in their midst. “Shout, O Israel! . . . The King of Israel, the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD ")]), _vm._v("is in your midst!” (Zeph 3:14-15 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESV")]), _vm._v(").")]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-018"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("9:1-2 "), _c('i', [_vm._v("The Truth in Christ About Predestination")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WEARS TO ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELL THE ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RUTH")]), _vm._v(". ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVID ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AREUS")]), _vm._v(": “I tell you the truth in Christ.” Since the apostle is about to speak concerning the rejection of the Jews and the substitution of the Gentiles, he uses a holy and serious protestation, such as is not found elsewhere in the Scripture. He was led to do so not by fear but by necessity. He knew that he was hated by the Jews on the score that he had defected from Moses to Christ owing to his inconstancy and was teaching a gospel out of hatred for the law. From this understanding it could appear that he wanted to insult the Jews out of some ill-will and flatter the Romans. In order to deflect such suspicions, he most solemnly prefaces his remarks concerning his more-than-human affection toward the Jews, showing that that was far from the case, that he was laboring here with some "), _c('i', [_vm._v("epichairekakia")]), _vm._v(" [“joy over a neighbor’s "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("misfortune”] so that he was very grieved by the blindness of his people and their destruction, which he was prepared to redeem by giving up his own salvation. But in order that it may not be thought a trivial matter, and in order to win over their embittered souls instead, he confirms his statement with an oath, and at the same time piles up and proclaims the excellent praises of the Hebrews. Nonetheless, he comes to the point where he shows that they lack only one thing—without which the other things are of no benefit—namely, that they are hostile to Christ. . . .")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("With an oath he begins his complaint about the grief and torture of his heart because of his people’s rejection, which we said was the main point of his introduction. And he explains the reasons for his great grief. “I tell you the truth.” By taking an oath he averts the suspicion that his grief is feigned. He is saying, “I am not pretending at all, but I truly attest to my grief.” “I am not lying.” Someone can tell the truth and nevertheless lie by saying a true thing that he thinks is false. For lying is going against one’s own mind. For this reason the apostle attests the truthfulness in his words and the sincerity in his mind. He invokes three witnesses of the truth: “Christ,” whom he will soon call “God blessed forever.” He therefore appeals to the judgment seat of God. “His conscience,” which is like a thousand witnesses—and the worst torture if it is wronged. And “the Holy Spirit,” who cannot deceive or be deceived, since he is the Spirit of truth. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS ")]), _vm._v("9:1.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN114",
      "id": "ap_NFIN114-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RANTS A ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOD ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONSCIENCE")]), _vm._v(". ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMINGO DE ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTO")]), _vm._v(": If you should happen to look at the composition of the Greek word, you might perhaps say it means, “as my conscience calls C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST")]), _vm._v(" as a witness” or “as C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST")]), _vm._v(" gives witness at the same time.” But the meaning is not that the conscience and C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST")]), _vm._v(" give witness at the same time, but rather that C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST")]), _vm._v(" is the author of truth for the conscience. In order to remove this ambiguity, the interpreter translated it by this phrase, “as my conscience calls C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST")]), _vm._v(" as a witness,” which has the same meaning. Therefore he adds the testimony of the conscience as an explanation of the next word, “I am not lying,” for speaking contrary to one’s conscience is lying. But because the conscience can sometimes be mistaken, he adds, “In the Holy Spirit.” Just a little earlier he had said, “The Holy Spirit bears witness to our spirit,” because he is undoubtedly infallible. Therefore, just as when he says, “My conscience bears witness,” its meaning is that he said, “I am not lying,” so also when he says, “In the Holy Spirit,” it is an explanation of the previous word, “in C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESUS")]), _vm._v(",” because the Spirit is poured into us by the virtue of C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST")]), _vm._v(". C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS ")]), _vm._v("9:1."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN115",
      "id": "ap_NFIN115-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OY IN ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UFFERING")]), _vm._v(". ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARTIN ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHER")]), _vm._v(": From this text it is very clear that love is found not only in sweetness and delight but also in the greatest sorrow and bitterness. Indeed it rejoices and delights in bitterness and sorrow, because it regards the misery and suffering of others as if it were its own. Thus Christ even in the final and worst hour of his suffering was aglow with his deepest love, indeed according to blessed Hilary, it filled him with the greatest joy to suffer the greatest pain. For thus it is that “God is wonderful in his saints,” so that he causes them, at the very time they are suffering the greatest pains, also to experience the greatest joys. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CHOLIA ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS ")]), _vm._v("9:2."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN116",
      "id": "ap_NFIN116-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ADDENED, ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TRUGGLES TO ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PEAK")]), _vm._v(". ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIN")]), _vm._v(": Paul dexterously manages to cut short his sentence so that he does not yet fully express what he was going to say. It was not yet suitable to mention the destruction of the Jewish nation openly. . . . He thus intimates a great measure of sorrow as imperfect sentences are for the most part full of pathos. But he will presently express the cause of the sorrow, after having more fully testified "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("his sincerity. The perdition of the Jews caused very great anguish to Paul, though he knew that it happened through the will and providence of God.")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("We hence learn that the obedience we render to God’s providence does not prevent us from grieving at the destruction of the lost, though we know that they are thus doomed by the just judgment of God. For the same mind is capable of being influenced by these two feelings. When it looks to God it can willingly bear the ruin of those whom he has decreed to destroy; and when it reflects on these human beings it grieves their punishment. Therefore they are greatly deceived who say that godly people should be apathetic and heartless ["), _c('i', [_vm._v("apatheian kai analgēsian")]), _vm._v("], lest they should resist the decree of God. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS ")]), _vm._v("9:2.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN117",
      "id": "ap_NFIN117-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFFERENT ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORM, ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AME ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBSTANCE")]), _vm._v(". ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILEMANN ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESSHUS")]), _vm._v(": Since Paul is about to enter into a dispute about the gracious election of God and he is about to show that the children of God are not born out of a fleshly procreation and that the keeping of Mosaic rituals does not bring salvation, he first attests concerning his love toward the Jewish nation. For the Pharisees had been convinced that Paul was the chief enemy of the Jewish people, and they suspected that Paul was spreading abroad a new kind of teaching with the purpose of oppressing the Jews and wiping out the whole Mosaic order.")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("In order to free himself of this suspicion, he testifies with an oath that a boundless sorrow has overtaken him because of the blindness, stubbornness and destruction of his people. This grief is so great that he wishes to save his own people at the cost of his own eternal destruction. But nobody can declare a more ardent love than placing the other person’s safety above their own. With this most ardent feeling, the apostle tries to invite the Jews to consider his teaching. And he shows that it is not out of some private grudge with the intention of harming the Jews that he is spreading abroad the teaching of the justification of a person before God by faith and apart from the works of the law and that he abolishes circumcision and makes the Gentiles equal to the Jews and welcomes them into the fellowship of the church. Rather, it is because he was divinely commanded to do so, and the salvation of the whole church demands it.")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("To be sure, the minds of the wise are horribly offended when they hear that the old order (whether of the church or the government) is being overthrown by a new kind of teaching. And since the church and polity of Moses was established by God himself, not only were the Pharisees and political rulers offended but also the apostles themselves were greatly grieved, because they saw that that polity and temple along with all its ceremonies were coming to ruin. What is more, Paul sees not only the overturn of the polity but especially the people’s dreadful blindness and destruction. But here the Holy Spirit warns us not to be offended by the overthrow of the earlier regime, whether of the church or of the state, but always to pay attention to hearing the teaching and keeping it pure and sincere, not being scared off by the wicked people’s being offended, but putting the glory of God and the salvation of the church ahead of all other things. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS ")]), _vm._v("9:1-3."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN118",
      "id": "ap_NFIN118-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-019"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("9:3-4 "), _c('i', [_vm._v("The Vast and Glorious Riches of Earthly Israel")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST’S ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFLECTED IN ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL")]), _vm._v(". ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACQUES ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFÈVRE D’")]), _vm._v("É"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TAPLES")]), _vm._v(": Paul considered the so marvelous, so inseparable and insurmountable love of God and Christ toward us, and furthermore considered that out of zeal for his brothers according to the flesh he had been a persecutor of Christ (who had been so kind and extremely loving toward him), to such a degree that he was willing to be separated from Christ for their sake and for the sake of the ancestral traditions. Therefore he was not able not to be overcome with the greatest sadness and constant grief of heart, as someone who reflects that he has been so greatly ungrateful in the face of such great kindness. Therefore the love of Paul is not what is inseparable or insur"), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("mountable from every creature, but the love of Christ toward us, who lovingly causes the persecuting to rest and embraces the adversary. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS ")]), _vm._v("9:1-3.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN119",
      "id": "ap_NFIN119-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OES ")]), _c('i', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NATHEMA")])]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAN? ")])]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLET")]), _vm._v(": Here the apostle earnestly desires, yes longs intensely, that the Jews also, even though they refused to be called, may at length through divine grace be reckoned among the number of the called and of those who trust in God. This is what, out of his great love towards them, he now longs for; yes, even on condition that if only they be saved, he himself may be made accursed and an offering and victim for them, to be sacrificed for the propitiation of God. For this is the meaning of the Greek word "), _c('i', [_vm._v("anathema")]), _vm._v(", since the verb "), _c('i', [_vm._v("anathematize ")]), _vm._v(". . . denotes both “to execrate” and also “to devote,” that is, to assign and to dedicate. An anathema . . . is a victim over which one makes an oath. E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XPOSITION OF ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN120",
      "id": "ap_NFIN120-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERVENT ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVE FOR ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IS ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EOPLE")]), _vm._v(". ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIN")]), _vm._v(": Paul could not have expressed a greater ardor of love than what he testifies here. That is surely perfect love that does not refuse to die for the salvation of a friend. But there is another word added, "), _c('i', [_vm._v("anathema")]), _vm._v(", which proves that he speaks not only of temporal but also of eternal death; but he explains its meaning when he says “from Christ,” for it signifies a separation, and what is it to be separated from Christ, but to be excluded from the hope of salvation? It was then proof of the most ardent love that Paul hesitated not to wish for himself that condemnation which he saw impending over the Jews, in order to deliver them. . . . Many indeed doubt whether this was a lawful desire; but this doubt may be thus removed: the settled boundary of love is that it proceeds as far as the conscience permits; if then we love in God and not without God’s authority our love can never be too much. And such was the love of Paul; for seeing his own nation endued with so many of God’s benefits, he loved God’s gifts in them, and them on account of God’s gifts, and he deemed it a great evil that those gifts should perish, hence that his mind being overwhelmed he burst forth into this extreme wish. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS ")]), _vm._v("9:3."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN121",
      "id": "ap_NFIN121-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACRIFICIAL ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVE")]), _vm._v(". ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVID ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AREUS")]), _vm._v(": This is an example of the most vigorous love toward the brothers, by which we all ought to be bound in aiding our brothers’ salvation. It is very appropriate for shepherds to be devoted to their sheep, and such is the case in the example of Christ the Great Shepherd. But in his case alone did he mourn thoroughly as an example of such great love. He alone, out of pure love for us and indeed for his enemies, poured out his life for our salvation. But this is not a trivial argument for the divinity of Christ. For by God alone can there be an "), _c('i', [_vm._v("anathema")]), _vm._v(" or curse; only God can cast body and soul into hell. Therefore, because the apostle wishes that he were anathema to Christ, he indicates that Christ is true God, whose friendship means eternal blessing and whose rejection means an eternal curse. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS ")]), _vm._v("9:3."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN122",
      "id": "ap_NFIN122-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD’S ")]), _vm._v("Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ES ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IDDEN ")]), _vm._v("U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDER ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IS ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("O")]), _vm._v(". ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARTIN ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHER")]), _vm._v(": Those who are truly righteous in that they abound in love achieve this resignation without great sadness. For because of their abounding love for God they make all things possible, even enduring hell. And by reason of this facility they immediately escape the penalty of this kind. Indeed they have no need to fear being damned, for they willingly and happily submit to damnation for the sake of God. Rather it is they who are damned who try to escape damnation.")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("For even Christ suffered damnation and desertion more than all the saints. And it was not "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("easy for him to suffer, as some imagine. For he really and truly offered himself for our eternal condemnation to God the Father for us. And according to his human nature he acted in no way different than a human being to be eternally damned to hell. And on account of this love of his toward God, God immediately raised him from death and hell and thus devoured hell. This all his saints should imitate, some to a lesser and some to a greater degree, for the more perfect they have been in their love, the more readily and easily they can do this. But Christ underwent this with the greatest difficulty of all. Hence in many passages he complains about the agonies of hell.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN123",
      "id": "ap_NFIN123-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Those who shrink from this interpretation are still being ruled by the fancies of their flesh, thinking that to love oneself is to want or hope first of all for something good for oneself; but they do not understand what this kind of good is, and thus they do not know what it is to love. For to love is to hate oneself, to condemn oneself and to wish the worst, in accord with the statement of Christ: “Whoever hates his life in this world will keep it in eternal life.” But if someone says: “I do not love my life in this world because I am seeking what is good for it in the life to come,” I reply: You are doing this out of love for yourself, which is a worldly love, and therefore you still love your life in this world. Whoever loves himself in this way truly loves himself: he loves himself not in himself but in God, that is, in accord with the will of God, who hates, damns and wills evil to all sinners, that is, to all of us. For what is good in us is hidden, and that so deeply that it is hidden under its opposite. Thus our life is hidden under death, love for ourselves under hate for ourselves, glory under ignominy, salvation under damnation, our kingship under exile, heaven under hell, wisdom under foolishness, righteousness under sin, power under weakness. And universally our every assertion of anything good is hidden under the denial of it, so that faith may have its place in God, who is a negative essence and goodness and wisdom and righteousness, who cannot be possessed or touched except by the negation of all our affirmatives. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CHOLIA ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS ")]), _vm._v("9:3."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN124",
      "id": "ap_NFIN124-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HALLENGES THE ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SRAELITE ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFINITION OF THE ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RUE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH")]), _vm._v(". ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HILIPP ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELANCHTHON")]), _vm._v(": We establish this as the aim [of the text]: it teaches that one must distinguish the true and elected church from the one that has the title and the fleshly prerogatives. This is a necessary teaching against the magnificent show that the false church puts forth, namely, its antiquity, the examples of the fathers and the consensus of the crowd. When these things meet our eyes, let us distinguish the churches as Paul here distinguishes the people of God. The true people has been elected through mercy; it is the people that has the gospel.")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("But the Jews contended that they were the people of God because they were descendants of Abraham, had the law, the fathers, examples and miracles. From this they reasoned as follows:")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Major Premise")]), _vm._v(": Christ has not yet come, because when Christ comes he will save the people.")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Minor Premise")]), _vm._v(": The people has not been saved, but a certain few seditious persons boast they have been saved.")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Conclusion")]), _vm._v(": Therefore Christ has not yet come.")]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Here Paul responds to the minor premise and teaches that the people had been elected through mercy, not on account of fleshly prerogatives or because of the law. If the discussion of Paul is to be referred to this understanding, it will be easier, and it can be transferred to our use in order that we may learn which is the true church.")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Paul begins with a very serious complaint, in which he testifies that he is grieved by the destruction of his nation. All holy men ["), _c('i', [_vm._v("sancti viri")]), _vm._v("] suffer "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("intense grief when they consider that so great a multitude of human beings is being damned, and wonder at this secret counsel that the church is such a tiny crowd, weak and downcast. Chiefly it was a matter of grief to those born in this people that this nation should be rejected, since the fathers and the prophets came from it. Here let us ponder Paul’s argument in order that we may learn to fear God. If God did not spare those who were descendants of the fathers and of the prophets, about whom the promises openly spoke, how much less will he spare the Gentiles. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS ")]), _vm._v("(1540).")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN125",
      "id": "ap_NFIN125-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONOR OF ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SRAEL, ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD’S ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITHFULNESS")]), _vm._v(". ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIN")]), _vm._v(": The whole drift of Paul’s discourse is to this purpose, that though the Jews by their defection had produced an ungodly divorce between God and themselves, yet the light of God’s favor was not wholly extinguished, according to what he had also said in Romans 3. They had indeed become unbelievers and had broken his covenant, but still their unfaithfulness had not rendered void the faithfulness of God. For he had not only reserved for himself some remnant seed from the whole multitude, but had as yet continued, according to their hereditary right, the name of a church among them.")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("But though they had already stripped themselves of these ornaments, so that it availed them nothing to be called the children of Abraham, yet as there was a danger, lest through their fault the majesty of the gospel should be depreciated among the Gentiles, Paul does not regard what they deserved, but covers their baseness and disgraceful conduct by throwing veils over them, until the Gentiles were fully persuaded, that the gospel had flowed to them from the celestial fountain, from the sanctuary of God, from an elect nation. For the Lord passing by other nations had selected them as a people for himself, and had adopted them as children, as is often testified by Moses and the prophets. And not content simply to give them the name of children, the Lord calls them sometimes the first-begotten, and sometimes his beloved. . . . By these words he means, not only to set forth his kindness toward the people of Israel, but rather to exhibit the efficacy of adoption, through which the promise of the celestial inheritance is conveyed. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMAN ")]), _vm._v("9:4."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN126",
      "id": "ap_NFIN126-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OES ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL ")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAN BY THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVENANTS? ")])]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMINGO DE ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTO")]), _vm._v(": Indeed, he weaves together the qualities of sons in a picturesque and orderly manner. But in Greek it reads in the plural: "), _c('i', [_vm._v("diathēkai")]), _vm._v(", “testaments.” Now the same noun in the plural means “distributions of inheritances that are discharged after the death of the testator,” but in the singular it also means “an agreement among living people” and “the inheritance itself.” Thus, perhaps in order that it would mean “the agreements and covenants of God that he had made with them,” the translator rendered it as “testament.” For this reason Origen says, “Each time they sinned, they seem to have been disinherited.” And again, “Each time God was propitiated, called them back and led them back to the inheritance of his possession, God must be believed to have repaired the testament.” And God made a covenant with Abraham and the other fathers, as was related in Genesis. Other interpreters, when they read the plural noun, apply the word to the two testaments, namely the old and the new testaments, which Paul comments on. The first of those testaments was granted to them, but the second was promised. Nonetheless, if you read the singular, “testament,” understand it to mean the Old Testament. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS ")]), _vm._v("9:4."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN127",
      "id": "ap_NFIN127-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVENANTS AND ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROMISES, ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AW AND ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPEL")]), _vm._v(". ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILEMANN ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESSHUS")]), _vm._v(": “Testaments or Covenants”: There can be no doubt that he understands the law and the gospel. For these are the two covenants that God fashioned with the people of Israel: one on Mount Sinai according to "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("the Ten Commandments, in which he promised life and all good things on the condition that the law be fulfilled; the other, by which he promised the Messiah and offered freely for his sake the forgiveness of sins and the inheritance of eternal life to all who believe. The giving of the law is one kind of agreement or testament. It was an immense act of kindness that God renewed his law from heaven and informed us of his will.")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("The worship regulations, such as the ceremonies and rites prescribed by Moses, pertain to the old testament. Only in this people were true acts of worship—pleasing to God—being offered to God. For God had commanded them, and they were taking place in such a way that the promise of the Messiah shone forth. The Lord detested the other rituals done by the other nations. “The promises”: they are the other kind of testament, namely, the new testament, by which God promises the forgiveness of sins and eternal life through the Messiah. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS ")]), _vm._v("9:4.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN128",
      "id": "ap_NFIN128-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD’S ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REAT ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVE FOR THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HILDREN OF THE ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROMISE")]), _vm._v(". ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACQUES ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFÈVRE D’")]), _vm._v("É"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TAPLES")]), _vm._v(": The great love of God and kindness toward the Jews: He wanted to embrace and glorify them. And in no other nation did the Lord appear in the flesh, with the result that he himself could say, “I was not sent except to the sheep of the house of Israel who have perished.” Testaments were written with them. The Scripture indeed speaks about the old one: “Our Lord wrote a covenant with us at Horeb.” But it also speaks about the new one: “A festival for the house of Israel and a new covenant for the house of Judah, not like the one I wrote with your fathers.” And the first giving of the law was transmitted by Moses. The second law will go out from Christ out of Zion, as it had been written: “And the word of the Lord from Jerusalem.” Worship, that is, a manner of worship, was given to them so that they might worship the true God, while others worshiped not God but demons, for (he says) all the gods of the heathen are demons. And he made promises to them; nearly all the prophets are witnesses thereof. Their fathers were Abraham, Isaac and Jacob, from whom Christ the Lord wanted to trace his genealogy according to the flesh. For according to his divinity he had an eternal origin from the Father. And if the rest of the blessings seem trivial, nonetheless this is a great proof of his love toward them: Christ, who is God blessed above all things, deigned to take on flesh from them. But you will say, “If the promises concerning Christ were made to them and yet they did not receive him, as it is written, ‘He came to his own and his own did not receive him,’ then the proclamation of God was made void.” By no means. For the children of the promise are understood to be those who emulate the faith of Abraham, not merely those who descend from Abraham according to the flesh, and they are true Israelites and sons and seed of Abraham—not by the flesh, but by the Spirit. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS ")]), _vm._v("9:4-5."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN129",
      "id": "ap_NFIN129-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-020"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("9:5 "), _c('i', [_vm._v("The God-Man Belongs to Israel")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEAR ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITNESS OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST’S ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVINITY")]), _vm._v(". ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NGLISH ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS")]), _vm._v(": A most evident testimony and pregnant proof of Christ’s divinity! Blush for shame, says Oecumenius, and be confounded, O you wretched miscreant Arius, when you hear Christ glorified by the apostle with the title of God, in the singular number, with the article "), _c('i', [_vm._v("ho")]), _vm._v(", “the God,” or “only God” and “God over all” and blessed forever. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS ")]), _vm._v("9:5."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN130",
      "id": "ap_NFIN130-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REMIER ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LORY OF THE ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EWS ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEIR ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROTHER")]), _vm._v(". ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVIN")]), _vm._v(": "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("They who apply this to the fathers, as though Paul meant only to say that Christ had descended from the fathers, have no reason to allege. For his object was to close his account of the preeminence of the Jews by this encomium—that Christ proceeded from them. It was not a thing to be lightly esteemed, to have been united by a natural relationship with the Redeemer of the world. If he had honored the whole human race, in joining himself to us by a communion of nature, much more did he honor them, with whom he had a closer bond of union. It must at the same time be always maintained that when this favor of being allied by kindred is unconnected with godliness, it is so far from being an advantage that on the contrary it leads to a greater condemnation. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS ")]), _vm._v("9:5.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN131",
      "id": "ap_NFIN131-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HREE ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTERPRETATIONS OF “")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HO ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD OVER ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LL")]), _vm._v("."), _c('span', {
    staticClass: "small"
  }, [_vm._v("” ")])]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESIDERIUS ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RASMUS")]), _vm._v(": This passage can be construed in three ways. First the clause “who is above all” "), _c('i', [_vm._v("ho ōn epi pantōn ")]), _vm._v("may be joined to the preceding words and separated from the subsequent in this manner: “From whom is Christ according to the flesh—Christ who is above all” or “who was above all.” To forestall any suspicion that Christ’s honor was diminished through the human nature which he assumed, Paul added with a view to his divinity, “who is above all.” This construction attributes divinity to Christ, because nothing is above all except God alone. For "), _c('i', [_vm._v("epi")]), _vm._v(" is used in place of "), _c('i', [_vm._v("epanō.")]), _vm._v(" Then after a period, there would follow “God be blessed forever,” so that this would be an expression of thanks as a result of the contemplation of love toward the human race so great that God wished God the Son to assume a human body for our sake. But on this reading the article in "), _c('i', [_vm._v("ho ōn")]), _vm._v(" [“the one being”] is virtually superfluous; [while] in "), _c('i', [_vm._v("theos eulogētos ")]), _vm._v("[“God be blessed”], it is lacking.")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("In the second reading the entire passage sticks tightly together: “From whom is Christ according to the flesh, which Christ, since he is God above all, is . . . blessed forever.” This reading very clearly pronounces Christ God; but it would be easier if "), _c('i', [_vm._v("hos ōn")]), _vm._v(" [“who being”] had been written in place of "), _c('i', [_vm._v("ho ōn")]), _vm._v(" [“the one being”].")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("The third reading has no difficulties, at least on linguistic grounds—”from whom is Christ according to the flesh”; here a period ends the sentence. Then from a consideration of such great goodness of God, an expression of thanks is added, "), _c('i', [_vm._v("ho epi pantōn theos, eulogētos eis tous aiōnas")]), _vm._v(", that is “God who is above all be blessed forever.” Thus we would understand that the law that was given and the covenant and the prophets and finally Christ sent in human body—all of these things God, through an ineffable plan, provided to redeem the human race. Here if you take God to be the whole sacred Trinity (a meaning that frequently occurs in Sacred Literature, as when we are commanded to worship and serve God alone) Christ is not excluded. But if [“God” here] means the person of the Father (as is frequently true in Paul, especially when Christ or the Spirit is mentioned in the same passage) although from other passages in Scripture it is clearer than day that Christ, no less truly than the Father or the Holy Spirit, is called God, nevertheless this particular passage does not effectively refute the Arians, since nothing prevents it from being referred to the person of the Father. And so that those who claim from this passage that it is clearly demonstrated that Christ is openly called God, seem either to place little confidence in the witness of other scriptural texts; or to attribute no intelligence to the Arians, or they have not considered carefully enough the apostle’s language. There is a similar passage in [2 Corinthians] 11, where he says that the Father is blessed forever: “God and the Father of our Lord Jesus Christ, who is blessed forever.” For in the Greek there, “blessed” can be referred only to the Father. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNOTATIONS ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS ")]), _vm._v("9:5."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN132",
      "id": "ap_NFIN132-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROOF OF THE ")]), _vm._v("U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NION OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST’S ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WO ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATURES IN ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IS ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERSON")]), _vm._v(". ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILEMANN ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESSHUS")]), _vm._v(": Since the Mosaic polity was founded for the sake of the Messiah, the Son of God, so it was the chief glory of this people that Christ, the Almighty God, was born of the Jews. Also, it was the greatest sin of this people that they did not welcome the only-begotten Son of God, but defiled him with their blasphemies and crucified him. But in this passage Paul teaches the doctrine of the two natures in Christ, the human and the divine, united in one person. Christ is from the Jews according to the flesh; therefore Christ is true man, having flesh and blood, body and soul. He is also the eternal and almighty God above all things, begotten from the essence of the eternal Father. And these two natures are one person.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN133",
      "id": "ap_NFIN133-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" Therefore from this passage one must derive the teaching of the communication of attributes. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS ")]), _vm._v("9:5."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN134",
      "id": "ap_NFIN134-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NITY OF ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATURES IN ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST’S ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERSON")]), _vm._v(". ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHANNES ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RENZ")]), _vm._v(": Here Paul describes and demonstrates the person of Christ with few but indeed clear, distinct words, that he is true God and true man. For he says it in this way, “From their race Christ descended according to the flesh.” If that’s true, then he must be a true man. Right after that he adds, “Who is God over all, praised in eternity.” So then, Christ, according to his person, is true man and true God; yes, the man Christ is true God. And this is not just in name alone but also by the very reality itself. How else could he say “praised in eternity”? Indeed we cannot say such about any human being. Thus “the fullness of deity dwells bodily in him,” as Paul says of Christ in Colossians 2.")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("However, when we say, “the man Christ is God,” we want to demonstrate two things. First, the eternal, only-begotten Son of God, the second person in the divine essence, took on himself man or, as the epistle to the Hebrews says, the seed of Abraham, so that God and man became one inseparable person. Second, the Son of God poured the fullness of his deity on this man, whom he took on himself in the unity of his person, and made him omnipotent, omniscient, omnipresent, yes, a present Lord and Ruler. That is what we understand . . . when we say that the Son of Man is one person with the Son of God.")]), _c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Yes, that’s exactly what we otherwise call the "), _c('i', [_vm._v("communicatio idiomatum")]), _vm._v(", that is, a sharing and bond of the attributes of both natures in the one person of Christ. In this way and in such a form the Son of God took on himself man, so that he shared all his attributes, or as Paul says it, the whole fullness of his divinity bodily—however, without any harm and comingling of both substance and natures of the divinity and humanity. E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XPOSITION OF ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("T")]), _vm._v(". P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN135",
      "id": "ap_NFIN135-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASSAGE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEARLY ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EACHES THE ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YPOSTATIC ")]), _vm._v("U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NION")]), _vm._v(". ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVID ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AREUS")]), _vm._v(": The limitation “according to the flesh” teaches that in addition to his flesh there is in Christ another nature, a divine one, according to which he does not have his origin from among the Jews. The Greek article "), _c('i', [_vm._v("to")]), _vm._v(" [“the”] "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("emphatically indicates that here there is some different meaning than earlier in verse 3. “Who is God blessed above all.” Because he had restricted Christ’s origin from the Jews to his flesh or humanity, he also adds a reference to that according to which Christ does not originate from the Jews, namely, his divine nature, for he is not a mere human being, but also true God, existing in two natures in the unity of the person. It was opportune for him to mention here Christ’s divinity so that it might become apparent what sort of superiority the Jews had, in that Christ wanted to take on his flesh from the Jews: namely, because Christ was both man and God. But lest it be thought that he is calling him God in an unusual sense, in the way that magistrates and kings are called “gods” inasmuch as they are agents of God, he designates him with the epithet of “true God”: “The God who is "), _c('i', [_vm._v("epi pantōn")]), _vm._v(", ‘above all people’ or ‘above all things’”—which amounts to the same thing. He teaches that Christ is superior to all creatures and things. "), _c('i', [_vm._v("Eulogētos")]), _vm._v(", “Blessed for ever.” And from Romans 1:25 it is obvious that this ascription belongs to the true God alone, where God the Creator is honored with the same ascription. Heretics have labored from long ago to escape this divine praise of Christ. Erasmus also detracts not a little from it in his comments. . . . This passage, if any, is very clear about the person of Christ, the "), _c('i', [_vm._v("theanthrōpōs")]), _vm._v(" [“God-Man”].")])]), _c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("First, he teaches that Christ is the true and eternal God, blessed above all things forever, who alone is God the creator (1:25). Second, but he is also true man, endowed with flesh and a human soul, the offspring of Jewish ancestors. Third, he exists in two true, distinct natures that are joined hypostatically, the divine and human natures, because the same person originated from the fathers who is also God blessed forever. Fourth, finally, all divine and human things correspond in Christ according to their distinct natures. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS ")]), _vm._v("9:5.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN136",
      "id": "ap_NFIN136-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TERNAL ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAISE")]), _vm._v(". ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESIDERIUS ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RASMUS")]), _vm._v(": Christ is a man in such a way that at the same time he is also God, not the god peculiar to this or that nation, but the God of the whole world, and a God who is one with the Father. He is in command of all, and all these things are carried out by his inscrutable wisdom. Because of such an unusual love for the human race, praise and thanksgiving are owed to him for all eternity. Amen. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARAPHRASE ON ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS ")]), _vm._v("9:5."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN137",
      "id": "ap_NFIN137-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])])])]), _c('div', {
    staticClass: "defnotes"
  }, [_c('div', {
    staticClass: "ntb",
    attrs: {
      "id": "NTB1"
    }
  }, [_c('div', {
    staticClass: "numero"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap2#ap_NTB1-1"
    }
  }, [_vm._v("*1")]), _vm._v(". ")]), _c('div', {
    staticClass: "texte_note"
  }, [_c('p', [_vm._v("Or "), _c('i', [_vm._v("brothers and sisters")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09aa1e8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap2.vue
// module id = 87
// module chunks = 0